<template>
  <div class="mb-4">
    <h4>{{ loan.type }}</h4>
    <ul>
      <li v-for="(req, idx) in loan.requirements" :key="idx">{{ req }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LoanItem',
  props: {
    loan: Object
  }
}
</script>
